<!-- NAVBAR -->
<nav class="navbar navbar-expand-lg navbar-dark" style="background:#0b1f3a;">
  <div class="container">
    <a class="navbar-brand fw-bold" href="#">SwipFx</a>

    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#swipfxNav"
      aria-controls="swipfxNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="swipfxNav">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <ng-container *ngIf="canUseAccountFunctions">
        <li class="nav-item">
          <a [class]="page == 'Dashboard' ? 'nav-link active' : 'nav-link'" [routerLink]="['/dashboard']">Dashboard</a>
        </li>
        <li class="nav-item">
          <a [class]="page == 'Market' ? 'nav-link active' : 'nav-link'" [routerLink]="['/markets']">Market</a>
        </li>
        <li class="nav-item">
          <a [class]="page == 'Orders' ? 'nav-link active' : 'nav-link'" [routerLink]="['/orders']">Orders</a>
        </li>
        <li class="nav-item">
          <a [class]="page == 'Wallets' ? 'nav-link active' : 'nav-link'" [routerLink]="['/wallets']">Wallets</a>
        </li>
        <li class="nav-item">
          <a [class]="page == 'Support' ? 'nav-link active' : 'nav-link'" [routerLink]="['/support']">Support</a>
        </li>
        </ng-container>
        <li class="nav-item" *ngIf="isComplianceReviewerOnly">
          <a [class]="page == 'Document Reviews' ? 'nav-link active' : 'nav-link'" [routerLink]="['/review/additional-documents']">
            Document Reviews
          </a>
        </li>
        <app-admin-dropdown [page]="page"></app-admin-dropdown>
      </ul>


      <ng-container *ngIf="!userData; else loggedInBlock">
        <div class="d-flex gap-2">
          <a class="btn btn-outline-secondary btn-sm" [routerLink]="['/auth', 'login']">
            Sign in
          </a>
          <a class="btn btn-primary btn-sm" [routerLink]="['/auth', 'register']">
            Create account
          </a>
        </div>
      </ng-container>

      <ng-template #loggedInBlock>
        <ul class="navbar-nav ms-auto align-items-lg-center">
          <li class="nav-item me-lg-2">
            <a class="nav-link notification-link position-relative" [routerLink]="['/account/notifications']" aria-label="Notifications">
              <span aria-hidden="true">🔔</span>
              <span *ngIf="notificationUnread > 0" class="notification-badge badge rounded-pill text-bg-danger">
                {{ notificationUnread > 99 ? '99+' : notificationUnread }}
              </span>
            </a>
          </li>
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle d-flex align-items-center gap-2" href="#" role="button"
              data-bs-toggle="dropdown" aria-expanded="false">
              <span
                class="rounded-circle bg-white bg-opacity-25 d-inline-flex align-items-center justify-content-center"
                style="width:32px;height:32px;">
                <span class="fw-semibold">{{initials}}</span>
              </span>
              <span class="d-none d-lg-inline">{{displayName}}</span>
            </a>
            <ul class="dropdown-menu dropdown-menu-end">
              <li><a class="dropdown-item" [routerLink]="['/account']">Profile</a></li>
              <li *ngIf="canUseAccountFunctions"><a class="dropdown-item" [routerLink]="['/compliance']">My Compliance</a></li>
              <li *ngIf="canUseAccountFunctions"><a class="dropdown-item" [routerLink]="['/account/additional-documents']">My Additional Documents</a></li>
              <li *ngIf="canUseAccountFunctions"><a class="dropdown-item" [routerLink]="['/support/tickets']">My Support Tickets</a></li>
              <li><a class="dropdown-item d-flex justify-content-between align-items-center" [routerLink]="['/account/notifications']">
                <span>Notifications</span>
                <span *ngIf="notificationUnread > 0" class="badge rounded-pill text-bg-danger">{{ notificationUnread > 99 ? '99+' : notificationUnread }}</span>
              </a></li>
              <li *ngIf="canReviewAdditionalDocuments"><a class="dropdown-item" [routerLink]="[documentReviewUrl]">Document Reviews</a></li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li>
                <a class="dropdown-item text-danger" href="javascript:void(0)" (click)="logout()">
                  Logout
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </ng-template>
    </div>
  </div>
</nav>
<div class="container py-3" *ngIf="userData && showNotice && hideNotice()">
  <div class="alert alert-warning border-warning shadow-sm mb-0">
    <div class="d-flex align-items-start gap-3">
      <div class="fs-2 lh-1">⚠️</div>

      <div class="flex-grow-1">
        <h6 class="fw-bold mb-1">Verification Required</h6>

        <div class="mb-2">
          Hey {{ userData.firstName }}, you have not started your KYC and Compliance yet.
          Some SwipFx features may remain unavailable until your verification is completed.
        </div>

        <button class="btn btn-warning btn-sm" [routerLink]="['/account']" [queryParams]="{ tab: 'tabKyc' }">
          Start Verification
        </button>
      </div>
    </div>
  </div>
</div>